class HappyTailsBundleSelector {
  constructor(selector) {
    this.selector = selector;
    this.form = selector.closest('form');
    this.quantityInput = this.form?.querySelector('[name="quantity"]');
    this.submitLabel = this.form?.querySelector('[name="add"] > span');
    this.options = Array.from(selector.querySelectorAll('[data-happy-tails-bundle-option]'));
    this.priceContainer = document.getElementById(selector.dataset.priceTargetId);
    this.priceMain = this.priceContainer?.querySelector('.price__main__value');
    this.priceRegular = this.priceContainer?.querySelector('.price__regular');

    if (!this.form || !this.quantityInput || !this.submitLabel || this.options.length === 0) return;

    this.options.forEach((option) => {
      option.addEventListener('click', () => this.select(option));
      option.addEventListener('keydown', (event) => this.handleKeydown(event, option));
    });

    this.select(this.options.find((option) => option.classList.contains('is-selected')) || this.options[0], false);
  }

  select(option, shouldFocus = true) {
    const quantity = Number(option.dataset.quantity);
    if (!Number.isInteger(quantity) || quantity < 1) return;

    this.options.forEach((item) => {
      const selected = item === option;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-checked', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });

    this.quantityInput.value = String(quantity);
    this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    this.submitLabel.textContent = option.dataset.buttonLabel || 'Add to cart';
    this.updateDisplayedPrice(option);

    if (shouldFocus) option.focus();
  }

  updateDisplayedPrice(option) {
    if (!this.priceMain || !option.dataset.price) return;

    this.priceMain.textContent = option.dataset.price;

    if (this.priceRegular && option.dataset.comparePrice) {
      this.priceRegular.textContent = option.dataset.comparePrice;
    }
  }

  handleKeydown(event, option) {
    const currentIndex = this.options.indexOf(option);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.options.length;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.options.length) % this.options.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.options.length - 1;

    if (nextIndex !== currentIndex) {
      event.preventDefault();
      this.select(this.options[nextIndex]);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-happy-tails-bundle-selector]').forEach((selector) => {
    new HappyTailsBundleSelector(selector);
  });
});
